import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class IDPhotosEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  get(visitId: number): Observable<VisitDetailPhotos.IdPhotoResponse> {
    return this.http.get<VisitDetailPhotos.IdPhotoResponse>(
      `${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/idphotos?polling=true`,
    );
  }
}
